<template>
  <div v-infinite-scroll="loadMore">
    <loader :loading="loading"/>
    <div v-if="!loading">
      <page-title :image="listLogo" :title="listTitle" v-if="listTitle">
        <template slot="header-right">
          <slot name="header-actions"/>
        </template>
      </page-title>
      <panel :title="filterTitle" v-if="$slots['filters']">
        <span slot="header-right" class="badge badge--default">{{ $tc('items.found.label', total, { count: total }) }}</span>
        <form @submit.prevent="onSearch" id="list-search">
          <div class="l-row">
            <slot name="filters"/>
          </div>
          <div class="u-textRight">
            <button type="reset" class="btn" @click="clearFilters">
              Limpar filtros
            </button>
            <button :disabled="loading" v-bind:class="{ 'is-loading': loading }" class="btn btn--success" type="submit">
              <i class="icon-search size"></i>&nbsp;
              Pesquisar
            </button>
          </div>
        </form>
      </panel>
      <div class="actions" v-if="$slots['top-actions-left'] || $slots['top-actions-right']">
        <div v-if="$slots['top-actions-left']" class="l-row left">
          <slot name="top-actions-left"/>
        </div>
        <div class="l-row right">
          <slot name="top-actions-right"/>
        </div>
      </div>
      <div class="l-row vertical-flex">
        <slot/>

        <loader :loading="options.fetchingMore" :overlay="false"/>
      </div>

      <div class="no-more u-textCenter" v-if="!options.fetchingMore && !hasNext">Não existem mais registros</div>

      <div class="l-row">
        <slot name="bottom-actions"/>
      </div>
    </div>
  </div>
</template>

<script>
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import SortSelect from '@/components/template/SortSelect'
  import Paginator from '@/components/template/Paginator'
  import PageTitle from '@/components/template/PageTitle'

  export default {
    data: () => ({
      options: {
        page: 1,
        limit: 15,
        fetchingMore: false
      },
      hasNext: true
    }),
    created () {
      if (this.emitChangeOnCreated) {
        this.emitChange()
      }
    },
    methods: {
      onSearch () {
        this.options.page = 1
        this.emitChange()
      },
      emitChange () {
        this.$emit('change', this.options)
      },
      loadMore () {
        if (this.total === 0) {
          return false
        }

        if (this.options.page < (this.total / this.options.limit)) {
          this.options.fetchingMore = true

          this.options.page++

          this.$emit('loadMore', this.options)

          this.hasNext = this.options.page < (this.total / this.options.limit)
        } else if (this.options.page >= (this.total / this.options.limit)) {
          this.hasNext = false
        }
      },
      clearFilters () {
        for (let i in this.$parent.options) {
          this.$parent.options[i] = null
        }

        this.$emit('clearFilters')
      }
    },
    props: {
      loading: {
        type: Boolean,
        default: false
      },
      filterTitle: {
        type: String,
        default: ' ',
        required: false
      },
      total: {
        type: Number,
        default: 0,
        required: true
      },
      listLogo: {
        type: String,
        required: false
      },
      listTitle: {
        type: String,
        required: false
      },
      emitChangeOnCreated: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    components: {
      Panel,
      Loader,
      Paginator,
      SortSelect,
      PageTitle
    }
  }
</script>

<style lang="sass" scoped>
  .actions
    height: 45px

    .right
      width: 50%
      float: right

    .left
      width: 50%
      float: left
</style>



// WEBPACK FOOTER //
// Scroll.vue?72779d76